(function () {
  'use strict';

  function map2 (
    map2Factory,
    Translation,
    addressCalculationFactory,
    $timeout,
    postalCodesFactory,
    $document,
    Common
  ) {
    function link (scope, el) {
      let feature;
      let zipcode;
      let layerFilter;
      let index;
      let map = {};
      let popup;
      let computeAddressCountRequest;

      // models
      scope.hideShow = {};
      scope.alreadySelected = false;
      scope.fetchingSuggestions = false;
      scope.showGroupName = false;
      scope.showPostalcodes =
        Common.get('recipients.addressType', 'ADR') === 'ADR' ? true : false;
      scope.showPostalcodeBorder =
        Common.get('recipients.addressType', 'ADR') === 'ADR' ? true : false;
      scope.fetchingODRAreas = false;
      scope.fetchingSelectedAreas = false;

      // functions for map events -------------------------------
      // adds zipcode into the the zipcode list and highlight the selected zipcode
      function addZipcodeAreas (index, zipcode) {
        const type = scope.showPostalcodes ? 'postalcode' : 'postalcode_group';

        postalCodesFactory.zipcodes =
          angular.isDefined(postalCodesFactory.zipcodes) &&
          postalCodesFactory.zipcodes !== null
            ? postalCodesFactory.zipcodes
            : [];

        if (index < 0 && postalCodesFactory.zipcodes.indexOf(zipcode) < 0) {
          const reqData = {
            label: zipcode,
            type,
          };

          // rerendering map highlights
          highlightZipcodeAreas(postalCodesFactory.zipcodes);
          search(reqData, 'add', true);
        }
      }

      function buildFilter (selectedZipcodes) {
        // creates the filter
        const filter = ['in', 'postalcode', ''];

        // checks if there are any selected zipcodes
        if (selectedZipcodes.length === 0) {
          return filter;
        } else {
          // builds filter with selected zipcodes
          for (let i = 0; i < selectedZipcodes.length; i += 1) {
            filter.push(Number(selectedZipcodes[i]));
          }

          return filter;
        }
      }

      function removeAndRegroupCodes (reqData, fromMap) {
        addressCalculationFactory.forceLoadCount();
        postalCodesFactory.removeAndRegroupCodes(reqData).then((res) => {
          const refinedParams = scope.filterFn(res.group.postalcodes);
          refinedParams.zipcodes = res.group.postalcodes;
          refinedParams.postalCodeGroups = res.group.postalcodeGroup;

          postalCodesFactory.odrGroup = res.group;
          if (fromMap) {
            res.searchResults.forEach((item) => {
              postalCodesFactory.deleteFromSelectedList(
                item.county,
                item.municipality,
                item.postalcity,
                item.postalcode
              );
            });
          }
          Common.set('recipients.odrGroup', res.group);
          scope.fetchingSelectedAreas = false;
          highlightZipcodeAreas(postalCodesFactory.zipcodes);
          computeAddressCount(refinedParams);
          scope.fetchingODRAreas = false;
          postalCodesFactory.resetPostalcodesToBeRemoved();
        });
      }

      function deleteZipcodeAreasOnclick (e) {
        const codes = {
          0: 'id',
          1: 'postalcode',
        };

        const isPostalcode = Number(scope.showPostalcodes);

        // gets features of zipcode-area-highlight layer on click position
        feature = getMapUniqueFeatures((e || {}).point);

        // gets the zipcode of clicked feature
        zipcode = feature[0].properties[codes[isPostalcode]].toString();

        const type = scope.showPostalcodes ? 'postalcode' : 'postalcode_group';

        const reqData = {
          type,
          label: zipcode,
        };

        if (Common.get('recipients.addressType') === 'ADR') {
          search(reqData, 'remove', true);
        } else {
          scope.fetchingODRAreas = true;
          if (type === 'postalcode') {
            postalCodesFactory.postalcodesToBeRemoved.push(Number(zipcode));
          }

          removeAndRegroupCodes(reqData, true);
        }
      }

      // deletes area, postal codes from the selected list
      function deleteZipcodeAreasFromList (
        county,
        municipality,
        city,
        postalcode
      ) {
        const isODR = Common.get('recipients.addressType', 'ADR') === 'ODR';

        postalCodesFactory.deleteFromSelectedList(
          county,
          municipality,
          city,
          postalcode
        );
        highlightZipcodeAreas(postalCodesFactory.zipcodes);

        if (postalCodesFactory.zipcodes.length) {
          const refinedParams = scope.filterFn(postalCodesFactory.zipcodes);

          if (!isODR) {
            computeAddressCount(refinedParams);
            return;
          }

          let type = 'postalcode'; // default
          let label = postalcode; // default

          if (city && !postalcode) {
            type = 'postalcity';
            label = city;
          } else if (municipality && !city) {
            type = 'municipality';
            label = municipality;
          } else if (county && !municipality) {
            type = 'county';
            label = county;
          }

          const reqParams = {
            type,
            label,
          };

          removeAndRegroupCodes(reqParams);
        } else {
          addressCalculationFactory.resetAddressCount();
        }
      }

      function addToList (res, fromMap) {
        if (res.length === 0) {
          console.warn('addToList: No zipcodes to add');
          scope.fetchingSelectedAreas = false;
          return;
        }

        postalCodesFactory.structureListDisplay(res);

        if (!fromMap) {
          map2Factory.collectCoordinates(res, fitToRecentlySelectedArea); // add this function as callback
        }

        highlightZipcodeAreas(postalCodesFactory.zipcodes);

        const refinedParams = scope.filterFn(postalCodesFactory.zipcodes);

        scope.fetchingSelectedAreas = false;

        computeAddressCount(refinedParams);
      }

      function computeAddressCount (refinedParams) {
        $timeout.cancel(computeAddressCountRequest);
        computeAddressCountRequest = $timeout(function () {
          // Get the current postal codes
          const updatedRefinedParams = Object.assign({}, refinedParams, {
            zipcodes: postalCodesFactory.zipcodes,
          });
          addressCalculationFactory.computeAddressCount(updatedRefinedParams);
        }, 1000);
      }

      function odrAddToList (res, fromMap) {
        if (res.searchResults.length === 0) {
          console.warn('addToList: No zipcodes to add');
          scope.fetchingSelectedAreas = false;
          return;
        }

        postalCodesFactory.structureListDisplay(res.searchResults);

        if (!fromMap) {
          map2Factory.collectCoordinates(
            res.searchResults,
            fitToRecentlySelectedArea
          ); // add this function as callback
        }

        highlightZipcodeAreas(postalCodesFactory.zipcodes);

        const refinedParams = scope.filterFn(res.group.postalcodes);

        refinedParams.postalCodeGroups = res.group.postalcodeGroup;
        refinedParams.zipcodes = res.group.postalcodes;

        postalCodesFactory.odrGroup = res.group;
        Common.set('recipients.odrGroup', res.group);

        scope.fetchingSelectedAreas = false;
        scope.fetchingODRAreas = false;
        computeAddressCount(refinedParams);
      }

      function removeFromList (res) {
        (res.searchResults || res).forEach((item) => {
          deleteZipcodeAreasFromList(
            item.county,
            item.municipality,
            item.postalcity,
            item.postalcode
          );
        });

        scope.fetchingSelectedAreas = false;
      }

      // highlights zipcode areas
      function highlightZipcodeAreas (zipcodes) {
        // builds a filter for selected zicode areas
        layerFilter = buildFilter(zipcodes);

        // sets filter on the layers to highlight selected feature
        map.setFilter('zipcode-area-highlight', layerFilter);
        map.setFilter('zipcode-area-highlight-border', layerFilter);
      }

      function toggleMapLayer () {
        document.getElementById('map-layer-dropdown').classList.toggle('show');
      }

      // activates hover tooltip for selected areas
      function showMapHover (e) {
        // builds popup
        const description = e.features[0].properties.postalcode;
        popup.setLngLat(e.lngLat).setHTML(description).addTo(map);

        // display hover layer
        map.setFilter('zipcode-area-highlight-hover', [
          '==',
          'postalcode',
          e.features[0].properties.postalcode,
        ]);
      }

      // deactivate hover tooltip
      function hideMapHover () {
        popup.remove();
        map.setFilter('zipcode-area-highlight-hover', ['==', 'postalcode', '']);
      }

      // geolocation
      function locateUser () {
        const options = {
          enableHighAccuracy: true,
          trackUserLocation: true,
        };

        function success (pos) {
          const crd = pos.coords;

          // flies the map to the location
          map.flyTo({ center: [crd.longitude, crd.latitude], zoom: 14 });

          const markerIcon = document.createElement('div');
          markerIcon.className = 'marker';
          markerIcon.style.backgroundImage =
            'url(assets/images/ic-map-marker.png)';
          markerIcon.style.width = '12px';
          markerIcon.style.height = '17px';

          new mapboxgl.Marker(markerIcon)
            .setLngLat([crd.longitude, crd.latitude])
            .addTo(map);
        }

        function error (err) {
          console.log(`ERROR(${err.code}): ${err.message}`);
        }

        navigator.geolocation.getCurrentPosition(success, error, options);
      }

      function getActiveLayer (isPostalcode) {
        let activeLayer = 'zipcode-area';

        if (
          Common.get('recipients.addressType', 'ADR') === 'ODR' &&
          !isPostalcode
        ) {
          activeLayer = 'postalcodegroup-area';
        }

        return activeLayer;
      }

      // check for double feature
      function getMapUniqueFeatures (point) {
        const existingFeatureKeys = {};
        const isPostalcode = Number(scope.showPostalcodes);
        const layer = getActiveLayer(isPostalcode);
        const array = map.queryRenderedFeatures(point, { layers: [layer] });

        const uniqueFeatures = array.filter(function (feature) {
          if (existingFeatureKeys[feature.properties[layer]]) {
            return false;
          } else {
            existingFeatureKeys[feature.properties[layer]] = true;
            return true;
          }
        });

        return uniqueFeatures;
      }

      function checkCodeIndex (code, isPostalcode) {
        const arr = {
          0: Common.get('recipients.odrGroup.postalcodeGroup', []),
          1: postalCodesFactory.zipcodes,
        };
        return arr[isPostalcode].indexOf(Number(code));
      }

      function selectZipcodeAreasOnclick (e) {
        const codes = {
          0: 'id',
          1: 'postalcode',
        };

        const isPostalcode = Number(scope.showPostalcodes);

        // gets features of zipcode-area layer on click position
        feature = getMapUniqueFeatures(e.point);
        // gets the zipcode of clicked feature
        zipcode = feature[0].properties[codes[isPostalcode]].toString();

        // gets the position of zipcode in array
        if (angular.isDefined(feature)) {
          index = checkCodeIndex(zipcode, isPostalcode);
        }

        if (index < 0) {
          // adds selected zipcode area to the array
          addZipcodeAreas(index, zipcode);
        }
      }

      // start the feature selection function, fires when clicked on 'select-btn'
      function initOnClickSelection () {
        // changes the cursor to pointer
        map.getCanvas().style.cursor = 'pointer';

        // activates feature selection of zipcode areas
        map.on('click', 'zipcode-area', selectZipcodeAreasOnclick);
        map.on('click', 'postalcodegroup-area', selectZipcodeAreasOnclick);

        // deactivates hover tooltip over selected zipcode areas
        map.off('mousemove', 'zipcode-area-highlight', showMapHover);
        map.off('mouseleave', 'zipcode-area-highlight', hideMapHover);

        // activates deletion of features, deletes on 'right click'
        map.on(
          'contextmenu',
          'zipcode-area-highlight',
          deleteZipcodeAreasOnclick
        );
        // hiding this for now because this creates bugs
        // deletes selected area
        // map.on('click', 'zipcode-area-highlight', deleteZipcodeAreasOnclick);
      }

      // ends the feature selection function, fires when clicked on 'pan-btn'
      function endOnClickSelection () {
        // changes cursor to default
        map.getCanvas().style.cursor = '';

        // deactivate feature selection of zipcode areas
        map.off('click', 'zipcode-area', selectZipcodeAreasOnclick);
        map.off('click', 'postalcodegroup-area', selectZipcodeAreasOnclick);

        // activates hover tooltip over selected zipcode areas
        map.on('mousemove', 'zipcode-area-highlight', showMapHover);
        map.on('mouseleave', 'zipcode-area-highlight', hideMapHover);

        // deactivate deletion of features
        map.off(
          'contextmenu',
          'zipcode-area-highlight',
          deleteZipcodeAreasOnclick
        );
        map.off('click', 'zipcode-area-highlight', deleteZipcodeAreasOnclick);
      }

      function fitMapToFeatures (bbox) {
        map.fitBounds(bbox, {
          maxZoom: 15,
          padding: 100,
        });
      }

      // fit recently selected areas
      function fitToRecentlySelectedArea (coordinates) {
        /* eslint-disable no-undef */
        const line = turf.multiLineString(coordinates);
        const bbox = turf.bbox(line);
        /* eslint-enable no-undef */

        fitMapToFeatures(bbox);
      }

      function getAllBbox () {
        map2Factory.getAllBbox(fitMapToFeatures);
      }

      // end ----------------------------------------------------

      // map controls
      function initControlButtons () {
        const controlContainer = document.getElementsByClassName(
          'mapboxgl-ctrl-group'
        );

        const fullscreenBtn = document.getElementsByClassName(
          'mapboxgl-ctrl-fullscreen'
        );
        const fullscreenIcon = document.createElement('i');

        fullscreenIcon.className = 'fal fa-expand';
        fullscreenBtn[0].className += ' bg-icon';
        fullscreenBtn[0].title = Translation.translate(
          'ADR_PAGE_FULL_SCREEN'
        ).value;
        fullscreenBtn[0].appendChild(fullscreenIcon);
        controlContainer[0].appendChild(fullscreenBtn[0]);

        const zoomInBtn = document.getElementsByClassName(
          'mapboxgl-ctrl-zoom-in'
        );
        const zoomInImg = document.createElement('img');
        zoomInImg.className = 'ic-map-plus';
        zoomInImg.src = 'assets/images/ic-map-plus.png';
        zoomInImg.srcset =
          'assets/images/ic-map-plus@2x.png, assets/images/ic-map-plus@3x.png';
        zoomInBtn[0].title = Translation.translate('ADR_PAGE_ZOOM_IN').value;
        zoomInBtn[0].appendChild(zoomInImg);
        controlContainer[1].appendChild(zoomInBtn[0]);

        const zoomOutBtn = document.getElementsByClassName(
          'mapboxgl-ctrl-zoom-out'
        );
        const zoomOutImg = document.createElement('img');
        zoomOutImg.className = 'ic-map-minus';
        zoomOutImg.src = 'assets/images/ic-map-minus.png';
        zoomOutImg.srcset =
          'assets/images/ic-map-minus@2x.png, assets/images/ic-map-minus@3x.png';
        zoomOutBtn[0].title = Translation.translate('ADR_PAGE_ZOOM_OUT').value;
        zoomOutBtn[0].appendChild(zoomOutImg);
        controlContainer[1].appendChild(zoomOutBtn[0]);

        const locateBtn = document.createElement('button');
        const locateImg = document.createElement('img');
        locateImg.className = 'ic-map-here';
        locateImg.src = 'assets/images/ic-map-here.png';
        locateBtn.type = 'button';
        locateBtn.id = 'ic-locate-btn';
        locateBtn.title = Translation.translate('ADR_PAGE_LOCATE_ME').value;
        locateBtn.appendChild(locateImg);
        controlContainer[1].appendChild(locateBtn);

        document.getElementById('ic-pointer-btn').onclick =
          initOnClickSelection;
        document.getElementById('ic-hand-btn').onclick = endOnClickSelection;
        document.getElementById('ic-locate-btn').onclick = locateUser;
        document.getElementById('ic-layer-btn').onclick = toggleMapLayer;
        document.getElementById('ic-fit-btn').onclick = getAllBbox;

        initOnClickSelection();
      }

      // this is where you add sources for your map
      function addSource () {
        map2Factory.sources.forEach(function (source) {
          map.addSource(source.name, source.options);
        });
      }

      function setPostalcodeLayer () {
        map.setLayoutProperty('zipcode-area', 'visibility', 'visible');
        map.setLayoutProperty('zipcode-area-border', 'visibility', 'visible');
        map.setLayoutProperty('zipcode-area-text', 'visibility', 'visible');
      }

      // this is where you add layers to the map
      function addLayers () {
        map2Factory.setToADRLayers();

        if (Common.get('recipients.addressType', 'ADR') === 'ODR') {
          map2Factory.addPostalCodeGroupLayers();
        }

        map2Factory.layers.forEach(function (layer) {
          map.addLayer(layer);
        });

        if (Common.get('recipients.addressType', 'ADR') === 'ADR') {
          setPostalcodeLayer();
        }
      }

      // NOTE: op means operation. values: add or remove
      function search (searchSelection, op, fromMap) {
        scope.alreadySelected = true;
        scope.fetchingSelectedAreas = true;
        const isODR = Number(
          Common.get('recipients.addressType', 'ADR') === 'ODR'
        );

        const searchCall = {
          0: postalCodesFactory.getCodes,
          1: postalCodesFactory.odrGetCodes,
        };

        const addFn = {
          add: {
            0: addToList,
            1: odrAddToList,
          },
          remove: {
            0: removeFromList,
          },
        };

        scope.fetchingODRAreas = !!isODR;

        searchCall[isODR](searchSelection)
          .then(function (res) {
            if (op) {
              addFn[op][isODR](res, fromMap);
            } else {
              // if there is no callback, update the group here
              postalCodesFactory.odrGroup = res.group;
              Common.set('recipients.odrGroup', res.group);
            }
          })
          .catch(function () {
            scope.fetchingSelectedAreas = false;
          });
      }

      // this is for ADR map layer
      function togglePostalBorder (model) {
        const status = {
          0: 'none',
          1: 'visible',
        };

        scope.showPostalcodeBorder = model;

        map.setLayoutProperty(
          'zipcode-area',
          'visibility',
          status[Number(model)]
        );
        map.setLayoutProperty(
          'zipcode-area-border',
          'visibility',
          status[Number(model)]
        );
        map.setLayoutProperty(
          'zipcode-area-highlight',
          'visibility',
          status[Number(model)]
        );
        map.setLayoutProperty(
          'zipcode-area-highlight-border',
          'visibility',
          status[Number(model)]
        );
        map.setLayoutProperty(
          'zipcode-area-highlight-hover',
          'visibility',
          status[Number(!model)]
        );
      }

      function togglePostalCodeLayer (model) {
        const status = {
          0: 'none',
          1: 'visible',
        };

        scope.showPostalcodes = model;
        map.setLayoutProperty(
          'zipcode-area-text',
          'visibility',
          status[Number(model)]
        );
      }

      function toggleLayers (model) {
        const postalcodeProperties = [
          'zipcode-area-text',
          'zipcode-area',
          'zipcode-area-border',
        ];

        scope.showPostalcodes = model;

        if (model) {
          postalcodeProperties.forEach((item) => {
            map.setLayoutProperty(item, 'visibility', 'visible');
          });

          map.setLayoutProperty('postalcodegroup-area', 'visibility', 'none');
        } else {
          postalcodeProperties.forEach((item) => {
            map.setLayoutProperty(item, 'visibility', 'none');
          });

          map.setLayoutProperty(
            'postalcodegroup-area',
            'visibility',
            'visible'
          );
        }
      }

      function toggleGroupName (model) {
        const status = {
          0: 'none',
          1: 'visible',
        };
        scope.showGroupName = model;

        map.setLayoutProperty(
          'postalcodegroup-name-text',
          'visibility',
          status[Number(model)]
        );
        map.setLayoutProperty(
          'postalcodegroup-text',
          'visibility',
          status[Number(!model)]
        );
      }

      function registerMapEvents () {
        let counter = 0;

        // change selected icons for hand and pointer
        el.find('#ic-pointer-btn').on('click', function () {
          el.find('.ic-map-pointer').replaceWith(
            '<img src="assets/images/ic-map-pointer-selected.png" srcset="assets/images/ic-map-pointer-selected@2x.png, assets/images/ic-map-pointer-selected@3x.png" class="ic-map-pointer-selected">'
          );
          el.find('.ic-map-hand-selected').replaceWith(
            '<img src="assets/images/ic-map-hand.png" srcset="assets/images/ic-map-hand@2x.png, assets/images/ic-map-hand@3x.png" class="ic-map-hand">'
          );
        });

        // change selected icons for hand and pointer
        el.find('#ic-hand-btn').on('click', function () {
          el.find('.ic-map-pointer-selected').replaceWith(
            '<img src="assets/images/ic-map-pointer.png" srcset="assets/images/ic-map-pointer@2x.png, assets/images/ic-map-pointer@3x.png" class="ic-map-pointer">'
          );
          el.find('.ic-map-hand').replaceWith(
            '<img src="assets/images/ic-map-hand-selected.png" srcset="assets/images/ic-map-hand-selected@2x.png, assets/images/ic-map-hand-selected@3x.png" class="ic-map-hand-selected">'
          );
        });

        // change search icon and animates the sidebar
        const searchHandlers = [
          function () {
            // var close = Translation.translate('ADR_PAGE_CLOSE').value;
            el.find('.map-toolbox-bg').animate({ marginLeft: '278px' }, 400);
            el.find('.map-search-bg').animate({ width: '278px' }, 400);
            el.find('.ic-search').replaceWith(
              '<img src="assets/images/ic-close.png" srcset="assets/images/ic-close@2x.png 2x, assets/images/ic-close@3x.png 3x" class="ic-close" title="' +
                Translation.translate('ADR_PAGE_CLOSE').value +
                '"/>'
            ); // ADR_PAGE_CLOSE
          },
          function () {
            el.find('.map-toolbox-bg').animate({ marginLeft: '0' }, 400);
            el.find('.map-search-bg').animate({ width: '0' }, 400);
            el.find('.ic-close').replaceWith(
              '<img src="assets/images/ic-search.png" srcset="assets/images/ic-search@2x.png 2x, assets/images/ic-search@3x.png 3x" class="ic-search" title="' +
                Translation.translate('SEARCH').value +
                '"/>'
            ); // SEARCH
          },
        ];

        el.find('#ic-search-btn').click(function () {
          searchHandlers[counter++].apply(
            this,
            Array.prototype.slice.apply(arguments)
          );
          counter %= searchHandlers.length;
        });
      }

      // map initialization
      function initMap (res) {
        map = new mapboxgl.Map({
          container: 'map',
          style: res,
        });

        popup = new mapboxgl.Popup({
          closeButton: false,
          closeOnClick: false,
        });

        // map tools (navigation = zoom control, fullscreen = fullscreen mode)
        const nav = new mapboxgl.NavigationControl({ showCompass: false });
        const fullscreen = new mapboxgl.FullscreenControl();

        map.addControl(fullscreen, 'top-right');
        map.addControl(nav, 'top-right');

        map.dragRotate.disable(); // disables map rotation and tilting

        // constrain map to just sweden
        map.setMaxBounds([
          [-13.648331179513576, 54.20704880505639], // NE point
          [46.2994431795411, 69.75996226576714], // SW point
        ]);

        // add layers to map
        map.on('load', function () {
          // adding sources to be used in the map
          addSource();
          // add layers to the map
          addLayers();
          // set events on map
          registerMapEvents();

          map.removeLayer('production_points'); // remove servicepoint markers on map

          if (postalCodesFactory.zipcodes.length) {
            highlightZipcodeAreas(postalCodesFactory.zipcodes);
            getAllBbox();
          }
        });

        initControlButtons();
      }

      // get style config first before initializing the map
      function getBaseMap () {
        map2Factory.getBaseMap().then(initMap);
      }

      function getZipcodes () {
        return postalCodesFactory.zipcodes;
      }

      // this is for iterating the list
      function getObjectKeys (obj, county) {
        if (county && !obj) {
          // always update list
          scope.searchList = postalCodesFactory.getSearchList();
          obj = scope.searchList;
        }

        return postalCodesFactory.getObjectKeys(obj);
      }

      // this is to check if the cascaded list is hidden
      function isHidden (key) {
        if (
          angular.isUndefined(scope.hideShow[key]) ||
          scope.hideShow === null
        ) {
          scope.hideShow[key] = false;
        }

        return scope.hideShow[key];
      }

      function querySearch () {
        postalCodesFactory.resetSuggestions();

        const whiteSpaceRegex = /^\s*$/;

        if (scope.searchTerm && !whiteSpaceRegex.test(scope.searchTerm)) {
          scope.alreadySelected = false;
          scope.fetchingSuggestions = true;
          postalCodesFactory
            .getSuggestions(scope.searchTerm)
            .then(function (res) {
              scope.searchSuggestions =
                postalCodesFactory.restructureSuggestions(res);
            })
            .finally(function () {
              scope.fetchingSuggestions = false;
            });
        } else {
          scope.searchSuggestions = {};
          scope.fetchingSuggestions = false; // just making sure that loading wont appear
        }

        return scope.searchSuggestions;
      }

      function getOdrFilter () {
        const filters = Common.get('recipients.odrFilters', {});
        const targetType = Common.get('recipients.targetType', 'INDIVIDUALS');

        return filters[targetType].formOfHousing;
      }

      function isOdr () {
        return Common.get('recipients.addressType', 'ADR') === 'ODR';
      }

      function isDefaultMap () {
        return Common.get('recipients.addressType', 'ADR') === 'ADR';
      }

      // start of map initialization
      $document.ready(getBaseMap);

      // method binding
      scope.getSearchList = postalCodesFactory.getSearchList;
      scope.getZipcodes = getZipcodes;
      scope.deleteZipcodeAreasFromList = deleteZipcodeAreasFromList;
      scope.getObjectKeys = getObjectKeys;
      scope.isHidden = isHidden;
      scope.querySearch = querySearch;
      scope.search = search;
      scope.addToList = addToList;
      scope.isOdr = isOdr;
      scope.getOdrFilter = getOdrFilter;
      scope.toggleLayers = toggleLayers;
      scope.toggleGroupName = toggleGroupName;
      scope.togglePostalCodeLayer = togglePostalCodeLayer;
      scope.togglePostalBorder = togglePostalBorder;
      scope.isDefaultMap = isDefaultMap;
    }

    return {
      restrict: 'E',
      templateUrl: 'components/recipients/map2/map.html',
      link: link,
      scope: {
        filterFn: '=',
        validityFn: '=',
      },
    };
  }

  angular.module('web2print.recipients').directive('map2', map2);

  map2.$inject = [
    'map2Factory',
    'Translation',
    'addressCalculationFactory',
    '$timeout',
    'postalCodesFactory',
    '$document',
    'Common',
  ];
})();
